import FileName from "../FileName";
import Spinner from "../../../../../Spinner";
import {useEffect, useMemo, useRef, useState} from "react";
import {v4 as uuid} from "uuid";
import filterResponse from "../../../../../../filterResponse";
import * as zip from "@zip.js/zip.js";
import {BlobReader, ZipReader} from "@zip.js/zip.js";
import Entry from "./Entry";
import DownloadFile from "../DownloadFile";

export default function PreviewArchiveFile({file, highlight}) {
	const id = useMemo(() => uuid(), [file.key]);
	const modelRef = useRef();
	const [loading, setLoading] = useState(true);
	const [entries, setEntries] = useState([]);
	const [blob, setBlob] = useState(null);

	const urlSearchParams = new URLSearchParams();
	urlSearchParams.append('originalFileName', file.fileName);

	useEffect(() => {
		let isMounted = true;
		const abortController = new AbortController();
		const modelReference = modelRef.current;

		async function onShown() {
			try {
				if (entries.length === 0) {
					setLoading(true);
					const response = await fetch(process.env.REACT_APP_ENDPOINT + '/files/' + file.key, {
						credentials: "include",
						signal: abortController.signal
					});
					await filterResponse(response);
					const blob = await response.blob();
					setBlob(blob);
					const zipFileReader = new BlobReader(blob);
					const zipReader = new ZipReader(zipFileReader);
					const entries = await zipReader.getEntries();
					isMounted && setEntries(entries);
					await zipReader.close();
				}
			}
			catch (e) {
				console.error(e);
			}
			finally {
				isMounted && setLoading(false);
			}
		}

		if (modelReference) {
			modelReference.addEventListener("shown.bs.modal", onShown);
		}

		return () => {
			abortController.abort();

			isMounted = false;
			if (modelReference) {
				modelReference.removeEventListener("shown.bs.modal", onShown);
			}
		};
	}, [file.key, id, entries.length]);

	function editEntry(entryId, blob) {
		setEntries(prev => {
			const newState = [...prev];
			newState.find(entry => entry.id === entryId).blob = blob;
			return newState;
		});
	}

	return (
		<>
			<a href={"#"} data-bs-toggle="modal" data-bs-target={"#previewFileModal" + id}>
				<FileName name={file.fileName} highlight={highlight} />
			</a>

			<div ref={modelRef} className="modal fade" id={"previewFileModal" + id} tabIndex="-1" aria-labelledby={"previewFileModalLabel" + id} aria-hidden="true">
				<div className="modal-dialog modal-fullscreen">
					<div className="modal-content">
						<div className="modal-header">
							<h1 className="modal-title fs-5" id={"previewFileModalLabel" + id}>Preview {file.fileName}</h1>
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div className="modal-body">
							<div className={"text-center"}>
								{loading && <Spinner />}
								{blob && <DownloadFile blob={blob} fileName={file.fileName}/>}
								<hr />
								<table className={"table text-start table-sm table-striped"}>
									<caption>Archive entries</caption>
									<thead className={"table-dark"}>
									<tr>
										<th>Filename</th>
										<th>File size</th>
									</tr>
									</thead>
									<tbody>
									{entries.map(entry => {
										return <Entry editEntry={editEntry} key={entry.filename} entry={entry}/>;
									})}
									</tbody>
								</table>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
